import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import { useSelector } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';

const SideBar = ({setGroupCode}) => {
    const [open, setOpen] = React.useState(false);
    const ItemGroup =useSelector((state) => state.item.itemGroup); 
    // const [groupCode, setGroupCode] = React.useState("");
    const toggleDrawer = (newOpen) => () => {
      setOpen(newOpen);
    };
  
    const DrawerList = (
      <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
        <List>
            {ItemGroup && ItemGroup.length > 0 ? (
            ItemGroup.map((group, index) => (
              <button
                className="categoryButton mb-auto"
                key={index}
                onClick={() => setGroupCode(group.itmsGrpCod)}
              >
                {group.itmsGrpNam}
              </button>
          ))) : (
            <p>No data available</p>
          )}
        </List>
      </Box>
    );
  
    return (
      <div className='menuIcon'>
        <Button onClick={toggleDrawer(true)} className='d-xxl-none'><MenuIcon/></Button>
        <Drawer open={open} onClose={toggleDrawer(false)}>
          {DrawerList}
        </Drawer>
      </div>
    );
  }


export default SideBar